// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"541":"385d5d0d","625":"7d28d133","727":"67dbacae","801":"a92052c1"}[chunkId] + ".chunk.js";
};